<template>
	<div v-if="organization" class="restaurant-item d-flex flex-wrap">
		<a href="" class="restaurant-item__inner"
			@click.prevent="toTop(), $router.push(`/restaurant/${organization.id}`)"
		>
			<div class="restaurant-item__image d-flex block-center">
				<img
					:src="`${organization.main_image}`"
					alt="restaurant image"
					class="restaurant-item__image-img"
				/>
			</div>
			<div class="restaurant-item__info d-flex flex-column">
				<span class="restaurant-item__info-title">{{ organization.name }}</span>
				<div
					v-if="renderTime(organization)"
					class="restaurant-item__info-schedule d-flex items-center"
				>
					<span class="icon-clock"></span>
					Открыто до {{ renderTime(organization) }}
				</div>
				<div class="restaurant-item__info-link d-flex block-center transition">
					<span class="icon-arrow-circle-right"></span>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
export default {
	name: 'RestaurantItem',
	components: {},
	props: {
		organization: {
			default: () => null,
		},
	},
	data() {
		return {};
	},
	methods: {
		renderTime(organization) {
			console.log(organization);
			let weekday = (new Date().getDay() + 6) % 7;
			let todayWorkDay = this.organization.work_days.find(
				(work_day) => work_day.weekday === weekday
			);

			let now = new Date();
			let nowDateTime = now.toISOString();
			let nowDate = nowDateTime.split('T')[0];
			if (todayWorkDay) {
				let endTime = new Date(nowDate + 'T' + todayWorkDay.end_time);
				return `${endTime.getHours()}:${
					endTime.getMinutes() > 9 ? '' : '0'
				}${endTime.getMinutes()}`;
			}
		},
		toTop() {
			window.scrollTo(0, 0);
		}
	},
};
</script>
